module.exports = "/lucky-balls/img/weager/Buy_Ticket_pressed.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Buy_Ticket_pressed.png
// module id = 1160
// module chunks = 0